import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdUserInsightsOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
const useEntityOtherInsights = id => {
  const $ = _c(5);
  let t0;
  if ($[0] !== id) {
    t0 = getEntitiesByFpIdUserInsightsOptions({
      path: {
        fpId: id
      }
    });
    $[0] = id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!id;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      ...t0,
      enabled: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(t2);
};
export default useEntityOtherInsights;